/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Device_Not_FoundInputs */

const vi_error_irrigation_device_not_found = /** @type {(inputs: Error_Irrigation_Device_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy bộ tưới này trên SmartLab, có thể mã đã bị đổi. Tải lại danh sách rồi thử lại.`)
};

/**

* @param {Error_Irrigation_Device_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_device_not_found = /** @type {((inputs?: Error_Irrigation_Device_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Device_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_device_not_found(inputs)
});